<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="overflow-x-hidden rounded-3xl">
    <div>
      <UpgradeRocketBanner
        viewBox="0 0 645 126"
        preserveAspectRatio="xMidYMin meet"
      />
    </div>
    <div class="flex flex-col items-center px-4 pt-6 pb-3">
      <h1 class="font-highlight my-3 text-3xl font-bold">
        {{ $t('upgrade.upgrade_required.title') }}
      </h1>
      <div class="text-lg">
        {{ $t('upgrade.upgrade_required.description') }}
      </div>
      <div class="text-lg">
        {{ $t('upgrade.upgrade_required.description_2') }}
      </div>
      <div class="mt-4">
        <TButton type="filled" color="primary" @click="router.upgrade()">
          {{ $t('upgrade.buy.cta') }}
        </TButton>
      </div>
      <div class="mt-3 flex flex-col items-center gap-2 text-center">
        <span v-html="$t('upgrade.buy.trainee.discount')"></span>
        <TraineeUpgradeButton :source="source" />
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { TButton } from '@teachino/shared-design-system';
import { $t } from '@teachino/shared-i18n';
import {
  type UpgradeSource,
  useGlobalDependencyProvider,
} from '@teachino/shared-util';
import { onMounted } from 'vue';
import TraineeUpgradeButton from './TraineeUpgradeButton.vue';
import UpgradeRocketBanner from './upgrade_rocket_banner.svg?component';

const di = useGlobalDependencyProvider();
const analytics = di.inject('analytics');
const router = di.inject('router');

const props = defineProps<{ source: UpgradeSource }>();

onMounted(() => {
  analytics.track('upgrade-open-dialog', { source: props.source });
});
</script>
